import { Controller as BaseController } from "@hotwired/stimulus";
import SlimSelect from "slim-select"
import "slim-select/styles"

export class Controller extends BaseController {
  static values = {
    addable: Boolean
  }

  connect() {
    const options = {
      select: this.element,
      settings: {
        maxValuesShown: 80,
        allowDeselect: true
      }
    }

    if (this.hasAddableValue && this.addableValue) {
      options.events = {
        addable: function(value) {
          return {
            text: value,
            value: value
          }
        }
      }
    }

    this.slim = new SlimSelect(options)
  }

  destroy() {
    this.slim.destroy()
  }
}
